module.exports = __webpack_public_path__ + "img/k10.000eb362.jpg";